import { FC, useState } from 'react';
import { WidgetCell, WidgetProps } from '../WidgetCell';
import { Link, Stack } from '@mui/material';
import { useDrawerContext } from '../../../../../drawer/DrawerContext';
import { useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';
import slugify from 'slugify';
import { widgetDefinitions } from '../widgetDefinitions';

export const SubactivitiesCell: FC<WidgetProps> = ({ activityId, activityName, widget: { subTouchpoints }, activities }) => {
	const { setDrawerWithoutPrevParams } = useDrawerContext();
	const intl = useIntl();
	const [editMode, setEditMode] = useState(false);
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const isSubactivity = /^\/journeys\/[^/]+\/detail\/subactivity\/[^/]+$/.test(pathname);
	const backToMainActivity = pathname.split('/subactivity')[0];

	return (
		<WidgetCell
			data-activity-widget-name={slugify(activityName, { lower: true })}
			data-activity-widget-type={widgetDefinitions.subactivities.type}
			showEditOnHover
			handleEditAction={
				isSubactivity
					? undefined
					: () => {
							setDrawerWithoutPrevParams('editActivities', { activityId }, () => setEditMode(false));
							setEditMode(true);
						}
			}
			editMode={editMode}
			tooltipText={intl.formatMessage({ id: 'journey.detail.widget.edit' })}
		>
			{!isSubactivity &&
				subTouchpoints.map((subTouchpoint) => {
					return (
						<Stack key={subTouchpoint.id} flexWrap={'nowrap'} direction={'row'} alignItems={'center'} gap={1} sx={{ cursor: 'pointer' }}>
							<Link
								component={'button'}
								onClick={() => navigate(`${pathname}/subactivity/${subTouchpoint.activity?.id}`)}
								rel={'noreferrer'}
								sx={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
							>
								{subTouchpoint.activity?.name}
							</Link>
						</Stack>
					);
				})}
			{/* This element shows link in 1st subactivity with link which redirects back to main activity */}
			<Stack flexWrap={'nowrap'} direction={'row'} alignItems={'center'} gap={1} sx={{ cursor: 'pointer' }}>
				<Link
					component={'button'}
					onClick={() => navigate(backToMainActivity)}
					rel={'noreferrer'}
					sx={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
				>
					{activities[0]?.touchpoint?.parentActivity?.name}
				</Link>
			</Stack>
		</WidgetCell>
	);
};
